import { Globe2, Mail, MapPin, Phone } from "lucide-react";
import useCompanyProfile from "../hooks/useCompanyProfile";
import { useSiteContent } from "../content/SiteContentContext";

export default function CompanyFooter() {
  const company = useCompanyProfile();
  const { content } = useSiteContent();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="page-width footer-grid">
        <div className="footer-brand-block">
          <strong data-testid="footer-brand">{company.name}</strong>
          <p data-testid="footer-copy">{content.footer_tagline}</p>
        </div>
        <section data-testid="footer-address-section">
          <h3>{content.footer_address_heading}</h3>
          <p><MapPin size={16} /> <span data-testid="footer-address">{company.address || "Address will be updated soon."}</span></p>
        </section>
        <section data-testid="footer-contact-section">
          <h3>{content.footer_contact_heading}</h3>
          <p><Phone size={16} /> <span data-testid="footer-phone">{company.phone || "Phone will be updated soon."}</span></p>
          <p><Mail size={16} /> <span data-testid="footer-email">{company.email || "Email will be updated soon."}</span></p>
        </section>
        <section data-testid="footer-website-section">
          <h3>{content.footer_website_heading}</h3>
          <p><Globe2 size={16} /> <span data-testid="footer-website">{company.website || "Website will be updated soon."}</span></p>
        </section>
      </div>
    </footer>
  );
}